<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" translate>{{'setup_4.page_title'}}</h1>

     <form>
          <div class="padding-botton-10" id="birthType">
               <ng-select [item-list]="items.birthTypes" id="birthTypeSelect"
                  [(ng-model)]="eligibility.birthType" size="15"  [(ng-error)]="error_invalidBirthType" >
                    <h2 translate>
                         {{'setup_4.questions.birthType'}}
                    </h2>
               </ng-select>

               <div [hidden]="hideMultiBirthTypeInfo()">
                    <information outer-style="width:100%">
                         <h2 translate>{{'setup_4.multiple_birth_info_box.title'}}</h2>
                         <div translate> 
                              {{'setup_4.multiple_birth_info_box.content' }}
                         </div>
                    </information>
               </div>
          </div>

          <div class="padding-botton-10" id="deliveredByOther">
               <ng-radio [item-list]="items.yesNoList" id="deliveredByOtherRadio"
                    [(ng-model)]="eligibility.deliveredByOther" 
                    [(ng-error)]="error_invalidDeliveredByOther" 
               >
                    <h2 translate>{{'setup_4.questions.deliveredByOther'}}</h2>
               </ng-radio>
               <div aria-live='polite'>
               <div [hidden]="!(eligibility.deliveredByOther === 'Y')">
                    
                    <ng-container *ngTemplateOutlet="additionalDoc_custody"></ng-container>
                    
               </div>
               </div>
          </div>

      </form>
      <div class="btn-div">

               <div [hidden]="(eligibility.deliveredByOther === 'Y')">
                        <button class="btn-next" title="{{Button.Next_alt | translate}}" (click)="onNextClick()" translate>
                              {{Button.Next}}
                        </button>
               </div>

               <div [hidden]="!(eligibility.deliveredByOther === 'Y')">
                  <div class="button-top">
                        <button class="btn-next2" title="{{Button.Next_alt | translate}}" (click)="onNextClick()" translate>
                              {{Button.Next}}
                        </button>
                  </div>
                  <div class="button-bottom">
                        <button class="btn-cancel2" title="{{Button.Cancel_alt | translate}}" (click)="onCancelApplication()" translate>
                              {{Button.Cancel}}
                        </button>
                  </div>
               </div>
      </div>
</div>


<!--Improvement - this can be exported to be a reusable code?-->
<ng-template id="additionalDoc_custody" #additionalDoc_custody>
         <addtional-doc></addtional-doc>
</ng-template>